import React, {useEffect, useState} from "react";
import styled from "styled-components";
import {useDispatch} from "react-redux";
import {loadAllAxis} from "../../axis/all-axis/axisAction";
import TabContainer from "../../tab/TabContainer";
import ProjectsContainer from "./ProjectsContainer";
import {
    ACTUAL_YEAR_FILTER,
    ALL_FILTER,
    LAST_LAST_YEAR_FILTER,
    LAST_YEAR_FILTER,
    NEXT_NEXT_YEAR_FILTER,
    NEXT_YEAR_FILTER
} from "../../tab/filterTypes";
import useTab from "../../../custom-hooks/useTab";

const RoadMap = () => {

    const dispatch = useDispatch()
    const date = new Date()
    const year = date.getFullYear()

    const [sectionsMenu, setSectionsMenu] = useState([])

    const {sections, toggleSection, activeTab} = useTab(sectionsMenu)

    useEffect(() => {
        setSectionsMenu([
            {key: ALL_FILTER, label: "Tous", state: true,},
            {key: LAST_LAST_YEAR_FILTER, label: year - 2, state: false,},
            {key: LAST_YEAR_FILTER, label: year - 1, state: false,},
            {key: ACTUAL_YEAR_FILTER, label: year, state: false,},
            {key: NEXT_YEAR_FILTER, label: year + 1, state: false,},
            {key: NEXT_NEXT_YEAR_FILTER, label: year + 2, state: false,}
        ])
    }, [year])


    useEffect(() => {
        dispatch(loadAllAxis())
    }, [dispatch])

    return (
        <Page>
            <h2> Roadmap </h2>
            <div>
                <p className={"txt-align"}> Découvrez ici quand les projets doivent finir pour chaque année et pour
                    chaque axe. </p>
                <p> Les projets sont triés en trois colonnes (commencé, non commencé, terminé) en fonction de leur date
                    de fin. </p>
            </div>
            <Container>
                <TabContainer selectedTab={activeTab} children={sections} toggleSection={toggleSection}/>
                <ProjectsContainer
                    activeTab={activeTab}
                    sections={sections}
                />
            </Container>
        </Page>
    )
}

export default RoadMap;

const Page = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2em;
  align-items: center;
  padding-bottom: 1em;
  width: 100%;
  @media (min-width: 900px) {
    padding-left: 1em;
  }
`
const Container = styled.div`
  padding: 1em;
  gap: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  height: 100%;
  width: 100%;
`